import { FunctionComponent, Fragment } from 'react'
import { isSafari } from 'react-device-detect'
import {
  MenuItem,
  MenuList,
  Popper,
  Grow,
  Paper,
  Checkbox,
  ListItemText,
  ClickAwayListener,
} from '@material-ui/core'
import chevronDownIcon from '@iconify-icons/akar-icons/chevron-down'
import {
  Wrapper,
  Container,
  Title,
  Icon,
  POPPER_Z_INDEX,
  InputLabel,
} from './Select.style'
import { SelectProps } from './Select.types'
import { useSelect } from './Select.utils'

const Select: FunctionComponent<SelectProps> = props => {
  const {
    isOpen,
    isPlaceholderVisible,
    anchorRef,
    getTitle,
    handleToggle,
    handleClear,
    handleClose,
    handleItemClick,
    handleListKeyDown,
  } = useSelect(props)
  const {
    options,
    value,
    label,
    multiselect = false,
    onClearLabel,
    onClear,
    dropdownPlacement = 'bottom-start',
    color = 'primary',
    placeholder,
    children,
    onInputClick,
    error,
    id,
    ...wrapperProps
  } = props

  const TransitionComponent = isSafari ? Fragment : Grow

  return (
    <Container variant="outlined" {...wrapperProps}>
      {label && <InputLabel isError={!!error}>{label}</InputLabel>}
      <Wrapper
        ref={anchorRef}
        onClick={handleToggle}
        isError={!!error}
        isOpen={isOpen}
        id={id}
      >
        <Title isError={!!error} isPlaceholder={isPlaceholderVisible}>
          {getTitle()}
        </Title>
        <Icon
          icon={chevronDownIcon}
          style={isOpen ? { transform: 'rotate(180deg)' } : undefined}
        />
      </Wrapper>
      <Popper
        open={isOpen}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        placement={dropdownPlacement}
        modifiers={{
          flip: {
            enabled: false,
          },
        }}
        style={{ zIndex: POPPER_Z_INDEX }}
      >
        {({ TransitionProps }) => (
          <TransitionComponent {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={isOpen} onKeyDown={handleListKeyDown}>
                  {onClearLabel && (
                    <MenuItem onClick={handleClear}>
                      <ListItemText primary={onClearLabel || placeholder} />
                    </MenuItem>
                  )}
                  {children ||
                    options?.map(option => (
                      <MenuItem
                        key={`Select-option-${option.title}`}
                        value={option.value}
                        onClick={() => handleItemClick(option.value)}
                      >
                        {multiselect && (
                          <Checkbox
                            color={color}
                            checked={value.includes(option.value)}
                          />
                        )}
                        <ListItemText primary={option.title} />
                      </MenuItem>
                    ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </TransitionComponent>
        )}
      </Popper>
    </Container>
  )
}

export default Select
